import { MergeRequestBase } from '../types/MergeRequest';
import { fetchAll } from './fetchAll';
import { getProject } from './getProject';

type GetMergeRequestsProps = {
  baseUrl: string;
  token: string;
  teamName: string;
};

export async function getMergeRequests({
  baseUrl,
  token,
  teamName,
}: GetMergeRequestsProps): Promise<MergeRequestBase[]> {
  if (!baseUrl || !token || !teamName) {
    throw new Error('Proxy base URL or team name not available');
  }
  const mergeRequestsRes = await fetchAll(`${baseUrl}/renovate-mrs`, token, {
    team: teamName,
    per_page: '100',
  });

  const uiMergeRequestsRes = await fetchAll(`${baseUrl}/renovate-mrs`, token, {
    team: teamName.concat('-ui'),
    per_page: '100',
  });

  mergeRequestsRes.push(...uiMergeRequestsRes);

  const projects = await Promise.all(
    mergeRequestsRes.map(mr =>
      getProject({
        baseUrl,
        token,
        projectId: mr.project_id,
      }),
    ),
  );

  return mergeRequestsRes.filter(
    (mr, idx) =>
      !projects[idx]?.archived &&
      mr?.web_url &&
      !mr.web_url.includes('deleted'),
  );
}
